import { signupConstants } from "./signupConstants";

export const signupReducer = (state = {}, action) => {
  switch (action.type) {
    case signupConstants.SIGNUP_PROCESSING:
      return {
        ...state,
        isProcessing: action.isProcessing
      };
    case signupConstants.SIGNUP_SUCCESS:
      return {
        ...state,
        data: action.user
      };
    case signupConstants.SIGNUP_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
};

export const checkUserExistenceReducer = (state = {}, action) => {
  switch (action.type) {
    case signupConstants.CHECK_USER_EXISTENCE_PROCESSING:
      return {
        ...state,
        isProcessing: action.isProcessing
      };
    case signupConstants.CHECK_USER_EXISTENCE_SUCCESS: {
      return {
        ...state,
        user_exists: action.data.user_exists
      };
    }
    case signupConstants.CHECK_USER_EXISTENCE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
};
